module.exports = __webpack_public_path__ + "static/lua_small_logo_dark-a1c61f424dffb3014f16535903196200.svg";